import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const PrivateRouteComponent = ({ component }) => {
    const { user } = useAuth();

    return user ? component : <Navigate to="/login" />;
};

export default PrivateRouteComponent;
